"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachmentItemModelToJSON = exports.AttachmentItemModelFromJSONTyped = exports.AttachmentItemModelFromJSON = void 0;
const _1 = require("./");
function AttachmentItemModelFromJSON(json) {
    return AttachmentItemModelFromJSONTyped(json, false);
}
exports.AttachmentItemModelFromJSON = AttachmentItemModelFromJSON;
function AttachmentItemModelFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'mimeType': json['mimeType'],
        'lightSpectrum': _1.LightSpectrumFromJSON(json['lightSpectrum']),
        'fileName': json['fileName'],
        'side': _1.AttachmentSideModelFromJSON(json['side']),
        'created': (new Date(json['created'])),
    };
}
exports.AttachmentItemModelFromJSONTyped = AttachmentItemModelFromJSONTyped;
function AttachmentItemModelToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'mimeType': value.mimeType,
        'lightSpectrum': _1.LightSpectrumToJSON(value.lightSpectrum),
        'fileName': value.fileName,
        'side': _1.AttachmentSideModelToJSON(value.side),
        'created': (value.created.toISOString()),
    };
}
exports.AttachmentItemModelToJSON = AttachmentItemModelToJSON;
//# sourceMappingURL=AttachmentItemModel.js.map